module.exports = __webpack_public_path__ + "static/john-c3d331630bce2d97282cc913e021d80b.png";